import { render, staticRenderFns } from "./chapters.vue?vue&type=template&id=7c7874ef&scoped=true"
import script from "./chapters.vue?vue&type=script&lang=js"
export * from "./chapters.vue?vue&type=script&lang=js"
import style0 from "./chapters.vue?vue&type=style&index=0&id=7c7874ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7874ef",
  null
  
)

export default component.exports